<template>
    <div></div>
</template>

<script>
    export default {
        name: "StoreValidationTransmitter",
        props: {
            stepName: {
                required: true,
                type: String
            },
            valid: {
                required: true,
                type: Boolean
            },
            section: {
                type: String
            }
        },
        watch: {
            valid: {
                handler(isValid) {
                    this.$store.commit('registration/setStepsValidationState', {step: this.stepName, isValid: isValid, section: this.section})
                },
                immediate: true
            }
        }
    }
</script>

<style scoped>

</style>
